import React, { useState, useRef } from 'react';

/**
 * TagInput — Pill-style tag entry with backspace-to-delete.
 *
 * Props:
 *   tags: string[]
 *   onChange: (tags: string[]) => void
 *   placeholder?: string
 */
export default function TagInput({ tags = [], onChange, placeholder = 'Add tag...' }) {
    const [input, setInput] = useState('');
    const inputRef = useRef(null);

    const addTag = (raw) => {
        const tag = raw.trim().toLowerCase().replace(/[^a-z0-9\-_]/g, '');
        if (tag && !tags.includes(tag)) {
            onChange([...tags, tag]);
        }
        setInput('');
    };

    const removeTag = (idx) => {
        onChange(tags.filter((_, i) => i !== idx));
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            if (input.trim()) addTag(input);
        } else if (e.key === 'Backspace' && !input && tags.length > 0) {
            removeTag(tags.length - 1);
        }
    };

    return (
        <div className="notes-tag-input" onClick={() => inputRef.current?.focus()}>
            {tags.map((tag, i) => (
                <span key={tag} className="notes-tag-pill">
                    #{tag}
                    <button
                        type="button"
                        className="notes-tag-remove"
                        onClick={(e) => { e.stopPropagation(); removeTag(i); }}
                        aria-label={`Remove tag ${tag}`}
                    >
                        &times;
                    </button>
                </span>
            ))}
            <input
                ref={inputRef}
                className="notes-tag-field"
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={() => { if (input.trim()) addTag(input); }}
                placeholder={tags.length === 0 ? placeholder : ''}
                spellCheck={false}
            />
        </div>
    );
}
